import { render, staticRenderFns } from "./OrderItemsTableRow.vue?vue&type=template&id=d1a4f542"
import script from "./OrderItemsTableRow.vue?vue&type=script&lang=js"
export * from "./OrderItemsTableRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports